import React from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import AsyncCreatableSelect from 'react-select/async-creatable';
import client from '../../client';
import { customSelectStyles, mapTagsFromAPIRequest } from '../../utils';

import { GET_BRANDS_CATEGORY_TAGS } from '../../graphql-client/queries';

function SubCategorySelect(props) {
  const {
    selectedBrands, handleBrandChange, brands, isCreatable,
  } = props;
  const loadOptions = async (input) => {
    if (input && input.trim().length < 2) {
      return [];
    }
    const res = await client.query({
      query: GET_BRANDS_CATEGORY_TAGS,
      variables: { categoryId: brands._id, searchKey: input },
    });
    if (res.data && res.data.getCategoryTags && res.data.getCategoryTags.data) {
      return mapTagsFromAPIRequest(res.data.getCategoryTags.data);
    }
    return [];
  };

  return (
    <div>
      {isCreatable ? (
        <AsyncCreatableSelect
          allowCreateWhileLoading={false}
          className="reactSelect multiSelect"
          styles={customSelectStyles}
          cacheOptions
          loadOptions={loadOptions}
          value={selectedBrands}
          onChange={handleBrandChange}
          isMulti
        />
      ) : (
        <AsyncSelect
          className="reactSelect multiSelect"
          styles={customSelectStyles}
          cacheOptions
          loadOptions={loadOptions}
          value={selectedBrands}
          onChange={handleBrandChange}
          isMulti
        />
      )}
    </div>
  );
}

SubCategorySelect.propTypes = {
  brands: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    subCategoryId: PropTypes.array,
  }),
  selectedBrands: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, name: PropTypes.string })),
  handleBrandChange: PropTypes.func.isRequired,
  isCreatable: PropTypes.bool,
};

SubCategorySelect.defaultProps = {
  brands: null,
  selectedBrands: null,
  isCreatable: false,
};

export default SubCategorySelect;
